<script setup>
import SaveButtons from '../commons/SaveButtons.vue';
import CustomInput from '../commons/CustomInput.vue';
import ReferenceCard from '../commons/ReferenceCard.vue';
import UnselectedIndicator from '../commons/UnselectedIndicator.vue';
import BottomActions from '../commons/BottomActions.vue';
import CustomLoading from '../commons/CustomLoading.vue';
import ModalProps from '../commons/ModalProps.vue';
import MediatorIndicatorEditor from '../MediatorIndicatorEditor';
import axios from 'axios';
import { urlMainAPI, defaultSuccess, showError } from "@/global";
</script>
<template>
    <section>
        <CustomLoading v-if="this.isReloading" msg="Armazenando Informações" />

        <UnselectedIndicator v-if="!isCreating && !selectedIndicator.id" />
        <section v-else>
            <section class="refs-container">
                <b-tabs class="refs-forms" align="start" lazy no-nav-style @activate-tab="handleActive"
                    v-model="tabIndex">
                    <b-tab :title="$t('gemeo-digital')" active class="ref-tab">
                        <section class="ref-content">
                            <section class="map-inputs">
                                <label for="mapTag">
                                    <span>{{ this.$t('selectedMap') }}</span>
                                    <input type="text" id="mapTag" :value="this.creatingReference.map"
                                        @change="() => this.creatingReference.label = this.creatingReference.map"
                                        readonly>
                                </label>

                                <label for="mapValue">
                                    <span>{{ this.$t('valor') }}</span>
                                    <input type="text" id="mapValue" :value="this.creatingReference.value" readonly>
                                </label>
                            </section>
                            <input class="searchMap" v-model="mappingSearch" type="text"
                                :placeholder="$t('procurar-mapeamento')">
                            <section class="map-list">
                                <section class="map-header">
                                    <span>Mapeamento</span>
                                    <span>Valor</span>
                                </section>
                                <section class="map-table">
                                    <section v-for="(map, idxMap) in this.searchMap()" :key="`map-${idxMap}`"
                                        @click.prevent="() => selectMapping(map.map, map.value)">
                                        <span>{{ map.map }}</span>
                                        <span>{{ map.value }}</span>
                                    </section>
                                </section>
                            </section>
                        </section>
                        <BottomActions :leftFunc="() => { }" :rightFunc="() => { }" leftLabel="Limpar"
                            :rightLabel="addLabel" rightIcon="add" />
                    </b-tab>
                    <b-tab :title="$t('fixedValue')" class="ref-tab">
                        <section class="ref-content">
                            <CustomInput id="colectorName" type="text" :title="$t('nome-da-constante')"
                                :modelRef="this.creatingReference.fixedName" :inputFunc="event => {
                                    this.creatingReference.fixedName = event.target.value
                                    this.creatingReference.label = event.target.value
                                }" :optList="[]" optValue="" optDisplay="" :useIdx="false" />
                            <CustomInput id="colectorName" type="number" :title="$t('valor-da-constante')"
                                :modelRef="this.creatingReference.value"
                                :inputFunc="event => this.creatingReference.value = event.target.value" :optList="[]"
                                optValue="" optDisplay="" :useIdx="false" />
                        </section>
                    </b-tab>
                    <b-tab :title="$t('outOfSpecificationTableIndicator')" class="ref-tab">
                        <section class="ref-content">
                            <CustomInput id="indToSeach" type="text" :title="$t('indicator-filter')"
                                :modelRef="filterIndicator"
                                :inputFunc="event => this.filterIndicator = event.target.value" :optList="[]"
                                optValue="" optDisplay="" :useIdx="false" />

                            <section class="ind-list-ref">
                                <section v-for="(ind, idx) in this.searchIndicator()"
                                    :key="`ind-${ind.indicatorId}-${idx}`" class="ind-ref">
                                    <p :title="ind.indicatorName">{{ ind.indicatorName }}</p>
                                    <section class="addIndBtns">
                                        <section class="addReal" @click="addIndToReference(ind, 'real')">
                                            <span>Real</span>
                                            <b-icon-plus-circle-fill />
                                        </section>
                                        <section class="addPrev" @click="addIndToReference(ind, 'prev')">
                                            <span>Previsto</span>
                                            <b-icon-plus-circle-fill />
                                        </section>
                                    </section>
                                </section>
                            </section>
                        </section>
                    </b-tab>
                    <b-tab :title="$t('plano-de-safra-0')" class="ref-tab">
                        <section class="ref-content">
                            <CustomInput id="colectorName" type="select" :title="$t('item-do-plano-de-safra-mensal')"
                                :modelRef="this.harvestSelected"
                                :inputFunc="(event) => this.harvestSelected = event.target.value"
                                :optList="this.harvestPlanList" optValue="planTag" optDisplay="planName"
                                :useIdx="false" />
                            <section class="harvestPlanInfo">
                                <p><strong>{{ this.$t('tag-name') }}</strong> <span>{{ this.harvestInfo.planTag
                                        }}</span>
                                </p>
                                <p><strong>{{ this.$t('valor') }}</strong> <span>{{ this.harvestInfo.value }}</span></p>
                                <p><strong>{{ this.$t('data-referencia') }}</strong> <span>{{ this.harvestInfo.dateTime
                                        }}</span></p>
                                <p><strong>{{ this.$t('ultima-atualizacao') }}</strong> <span>{{
                                    this.harvestInfo.lastUpdate
                                        }}</span></p>
                            </section>
                        </section>
                    </b-tab>
                    <BottomActions v-if="this.tabIndex != 2" :leftFunc="clearRefTabs" :rightFunc="createNewReference"
                        leftLabel="Limpar" :rightLabel="addLabel" rightIcon="add" />
                </b-tabs>
                <section class="reference-created">
                    <p>Referências Criadas</p>
                    <section class="refs-list">
                        <section v-for="(refC, idx) in this.createdReferences" :key="`${refC}-${idx}`"
                            class="referenceItem" :title="refC.label">
                            <span draggable="true" @dragstart="refDrag($event, refC)">{{ refC.label }}</span>
                            <section>
                                <b-icon-trash-fill title="Remover Referência"
                                    @click="() => openRemoveModal(refC)"></b-icon-trash-fill>
                                <b-icon-pencil-fill title="Editar Referência"
                                    @click="() => selectReference(refC)"></b-icon-pencil-fill>
                                <b-icon-plus-circle-fill title="Adicionar na Equação"
                                    @click="() => addToEquation(refC, 'reference')"></b-icon-plus-circle-fill>
                            </section>
                        </section>
                    </section>
                </section>
                <section>
                    <section class="real-equation prev-equation">
                        <p>Equação Prevista</p>
                        <section class="operations">
                            <section v-for="(item, itemIdx) in this.operationsAllowed" :key="`${item.group}-${itemIdx}`"
                                :class="`op-container ${item.group}`">
                                <p>{{ item.groupName }}</p>
                                <section>
                                    <ReferenceCard v-for="(op, idx) in item.ops" :key="`${op.label}-${idx}`"
                                        :reference="op" cardType="operation" deleteClass="" :title="op.tooltip"
                                        @click.native="handleOperation(item.group, op)" :customClass="item.group"
                                        :draggable="item.group != 'funcs'" @dragstart.native="refDrag($event, op)" />
                                </section>
                            </section>
                        </section>
                        <section class="equation">
                            <ReferenceCard v-for="(ref, idx) in this.equationList" :key="`${ref}-${idx}`"
                                :reference="ref" :id="`${ref.label}-${idx}-equation`" :cardType="ref.type"
                                deleteClass="deleteClass" customClass=""
                                @click.native="() => deleteInEquation(ref, idx)" :enterFunc="() => refEnter(ref, idx)"
                                :leaveFunc="() => refLeave(ref, idx)" :dropFunc="(evt) => refDrop(evt, ref, idx)" />
                        </section>
                        <BottomActions :leftFunc="clearEquation" :rightFunc="undoEquation" leftLabel="Limpar"
                            rightLabel="Desfazer" rightIcon="undo" />
                        <section v-if="this.validExp.status == false" class="validation">
                            <b-icon-exclamation-circle-fill></b-icon-exclamation-circle-fill>
                            <span>{{ this.validExp.msg }}</span>
                        </section>
                    </section>
                    <section class="limits">

                        <section class="limit-inputs">
                            <label for="supLimitVal">
                                <span>{{ this.$t('limite-superior') }}</span>
                                <input type="number" id="supLimitVal" :disabled="this.disableSup"
                                    :value="this.disableSup == true ? 0 : this.supLimit"
                                    @input="event => handleValueLimit('sup', event.target.value)" step="0.1"
                                    :min="this.idealVal">
                            </label>
                            <label for="idealVal">
                                <span>{{ this.$t('valor-ideal') }}</span>
                                <input type="number" id="idealVal" readonly :disabled="true" :value="this.idealVal">
                            </label>
                            <label for="infLimitVal">
                                <span>{{ this.$t('limite-inferior') }}</span>
                                <input type="number" id="infLimitVal" :disabled="this.disableInf"
                                    :value="this.disableInf == true ? 0 : this.infLimit" step="0.1"
                                    @input="event => handleValueLimit('inf', event.target.value)" :max="this.idealVal">
                            </label>
                            <label for="criticalRange">
                                <span>{{ this.$t('critico') }}</span>
                                <input type="number" id="criticalRange" min="0" :value="this.critic"
                                    @input="event => handleValueLimit('critic', Math.abs(event.target.value))">
                            </label>
                        </section>
                        <section class="limit-radios">
                            <label for="upLimit">
                                <input type="radio" id="upLimit" name="limitRadio" @change="handleCheckLimit('up')"
                                    :checked="this.limitCheck == 'up'">
                                <span>Limite Superior</span>
                            </label>
                            <label for="bothLimit">
                                <input type="radio" id="bothLimit" name="limitRadio" @change="handleCheckLimit('both')"
                                    :checked="this.limitCheck == 'both'">
                                <span>Ambos Limites</span>
                            </label>
                            <label for="infLimit">
                                <input type="radio" id="infLimit" name="limitRadio" @change="handleCheckLimit('down')"
                                    :checked="this.limitCheck == 'down'">
                                <span>Limite Inferior</span>
                            </label>
                        </section>
                    </section>
                </section>
            </section>
            <SaveButtons :isCreating="isCreating" :allowTab="allowTab" tabToEnable="abstract" nextTabName="Resumo"
                :enableCommit="enableSave" :saveFunc="applyCalculatedReferences" :clearFunc="clearChanges"
                :creationToKeep="isCreating ? toSaveOnLocal : {}" />
        </section>
        <b-modal id="funcModal" :title="modalOp.fullName" hide-footer>
            <ModalProps :modalType="modalOp.label" :addFunc="addFuncFormatToEquation"
                :references="this.createdReferences" :hasCondition="modalOp.hasCondit"
                :needWeight="modalOp.hasWeight" />
        </b-modal>

        <b-modal id="removeReferenceModal" title="Remover Referência" ok-variant=danger :ok-title="$t('yes')"
            :cancel-title="$t('no')" @cancel="$bvModal.hide('removeReferenceModal')" @ok="removeReference">
            <p>Deseja <strong>remover</strong> a referência <strong>{{ this.removingReference.label }}</strong>?
                Lembrando que essa ação também removerá a referência da equação.</p>
        </b-modal>
    </section>
</template>
<script>
export default {
    name: 'CalculatedReference',
    components: { SaveButtons, ReferenceCard, CustomInput, UnselectedIndicator, BottomActions, ModalProps, CustomLoading },
    props: {
        isCreating: Boolean,
        allowTab: Function,
        selectedIndicator: Object,
        reloadIndicator: Function
    },

    data() {
        return {
            loading: true,
            enableSave: false,
            isReloading: false,
            addLabel: "Adicionar",
            unitId: 1,
            tabIndex: 0,
            toSaveOnLocal: { type: 'calculated' },
            operationsAllowed: MediatorIndicatorEditor.operationsAllowed,
            createdReferences: [],
            equationList: [],
            originalcreatedReferences: [],
            originalequationList: [],
            modalOp: {},
            creatingReference: {},
            mappingList: [],
            harvestPlanList: [],
            harvestSelected: '',
            harvestInfo: {},
            removingReference: {},
            mappingSearch: '',
            referenceType: 'gemeo',
            filterIndicator: '',
            validExp: { status: true, msg: '' },
            disableSup: false,
            disableInf: false,
            idealVal: 0,
            supLimit: 0,
            infLimit: 0,
            critic: 0,
            limitCheck: 'both',
            edited: false,
            indicatorValuesCache: {},
        }
    },
    watch: {
        "equationList"() {
            let labelEquation = this.equationList.map(item => item.label);
            this.validExp = MediatorIndicatorEditor.validateEquation(labelEquation);

            if (this.validExp.status == true) {
                if (this.limitCheck != '') {
                    this.enableSave = true
                }

                let res = this.handleCalc(this.equationList);
                this.idealVal = res;
                this.updateLimitWhenEdit();
            }
        },

        "selectedIndicator"(ind) {
            if (ind.prevRefs && ind.prevRefs != []) {
                if (this.createdReferences && this.createdReferences != undefined) {
                    this.createdReferences = ind.prevRefs.createdReferences;
                    this.originalcreatedReferences = [...this.createdReferences];
                }
                if (this.equationList && this.equationList != undefined) {
                    this.equationList = ind.prevRefs.equation;
                    this.originalequationList = [...this.equationList]
                }
            }

            this.equationList.forEach(ref => {
                if (ref.type == 'gemeo' && (!ref.value || ref.value == undefined || ref.value == '')) {
                    let mapFound = this.mappingList.filter(item => item.map == ref.label)
                    if (mapFound.length > 0) {
                        ref.value = mapFound[0].value
                        ref.desc = mapFound[0].value
                    }
                }
            });

            let indRule = ind.indicatorRule.split(" ");

            if (indRule.length > 0) {
                this.handleCheckLimit(indRule[0]);

                this.critic = Number(indRule[2]);
                let res = this.handleCalc(this.equationList);
                this.idealVal = res
                this.updateLimitWhenEdit();
            }

            this.creatingReference = {};
            this.collectType = '';
            this.automType = '';
            this.addLabel = "Adicionar";
        },

        "harvestSelected"() {
            let plan = this.harvestPlanList.filter(item => item.planTag == this.harvestSelected)
            this.harvestInfo = plan[0]
            this.creatingReference = plan[0]
            this.creatingReference.type = "safra";
        },
    },

    async mounted() {
        // Carrega cache de valores dos indicadores
        try {
            const response = await axios.get(`${urlMainAPI}/getindicatorvaluesforeditor`);
            if (response.status === 200 && response.data) {
                this.indicatorValuesCache = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
            }
        } catch (error) {
            // Erro ao carregar cache
        }

        // Carrega listas de mapeamento e plano de safra
        if (this.mappingList.length == 0 || this.harvestPlanList.length == 0) {
            await MediatorIndicatorEditor.generateMapObj();
            await MediatorIndicatorEditor.getProductionPlanData();
        }

        // Carrega dados locais se estiver criando
        if (this.isCreating) {
            let localJSON = MediatorIndicatorEditor.calculated

            if (localJSON != null && localJSON != undefined && Object.keys(localJSON).length != 0 && Object.keys(localJSON).length > 1) {
                this.createdReferences = localJSON.createdRefs
                this.equationList = localJSON.equation

                this.disableSup = localJSON.disableSup
                this.disableInf = localJSON.disableInf
                this.idealVal = localJSON.idealVal
                this.supLimit = localJSON.supLimit
                this.infLimit = localJSON.infLimit
                this.critic = localJSON.critic
                this.limitCheck = localJSON.limitCheck

                this.toSaveOnLocal = MediatorIndicatorEditor.calculated;

                // Atualiza refValue dos indicadores externos do cache
                this.updateExternalIndicatorsFromCache();
            }
        }

        // Carrega referências anteriores se existirem
        if (this.selectedIndicator.prevRefs) {
            if (this.createdReferences && this.createdReferences != undefined) {
                this.createdReferences = this.selectedIndicator.prevRefs.createdReferences;
                this.originalcreatedReferences = [...this.createdReferences];
            }
            if (this.equationList && this.equationList != undefined) {
                this.equationList = this.selectedIndicator.prevRefs.equation;
                this.originalequationList = [...this.equationList]
            }

            let indRule = this.selectedIndicator.indicatorRule.split(" ");

            if (indRule.length > 0) {
                this.handleCheckLimit(indRule[0]);
                this.critic = Number(indRule[2]);
            }

            // Atualiza refValue dos indicadores externos do cache ANTES de calcular
            this.updateExternalIndicatorsFromCache();

            if (this.selectedIndicator.idealRes && this.selectedIndicator.idealRes != '-9999') {
                this.idealVal = this.selectedIndicator.idealRes;
            } else {
                let res = this.handleCalc(this.equationList)
                this.idealVal = res
            }

            let percentValue = (Number(this.critic) / 100) * Number(this.idealVal)
            this.supLimit = Number(this.idealVal) + Number(percentValue)
            this.infLimit = Number(this.idealVal) - Number(percentValue)

            this.creatingReference = {};
            this.collectType = '';
            this.automType = '';
        }

        let userLocal = localStorage.getItem("userKey");
        if (userLocal != undefined) {
            let unitId = JSON.parse(userLocal).UnitId;
            this.unitId = unitId != undefined ? unitId : 1;
        }
    },

    methods: {
        searchIndicator() {
            return this.filterIndicator != '' && this.filterIndicator != undefined ? MediatorIndicatorEditor.indicatorsList.filter(item => item.indicatorName.toLowerCase().includes(this.filterIndicator.toLowerCase())) : MediatorIndicatorEditor.indicatorsList;
        },

        searchMap() {
            return this.mappingSearch != '' && this.mappingSearch != undefined ? this.mappingList.filter(item => item.map.toLowerCase().includes(this.mappingSearch.toLowerCase())) : this.mappingList;
        },

        fetchIndicatorValue(tagName) {
            const value = this.indicatorValuesCache[tagName];

            if (value !== undefined && value !== null && value !== '-9999') {
                return parseFloat(value);
            }
            return null;
        },

        updateExternalIndicatorsFromCache() {
            if (!this.equationList || this.equationList.length === 0) {
                return;
            }

            this.equationList.forEach((item) => {
                if (item.type === 'reference' && item.structure && item.structure.type === 'external') {
                    const tagName = item.label;
                    const currentValue = this.fetchIndicatorValue(tagName);

                    if (currentValue !== null) {
                        item.structure.refValue = currentValue;
                    }
                }
            });
        },

        addToEquation(item, type) {
            if (item.type == 'gemeo') {
                item.desc = `Mapeamento XML\nValor: ${item.value}`
            } else if (item.type == 'fixed') {
                item.desc = `Valor Fixo\nValor: ${item.value}`
            }

            this.equationList.push({ label: item.label, type: type, structure: item });

            if (type == 'operation' && item.isFunc == true) this.equationList.push({ label: '(', type: 'operation', structure: { label: '(', isFunc: false, colorClass: '', tooltip: `Abrir Parêntese:\nExemplo:\n(valor_01 ...` } });

            if (this.isCreating) {
                this.updateStorage();
            }
        },

        addIndToReference(ind, type) {
            let indOriginObj = { ...ind }
            let indObj = {};

            if (type == 'real') {
                indOriginObj.type = "external";
                indObj = { label: ind.valueEquation, type: 'reference', structure: indOriginObj }
                indObj.structure.desc = `Indicador Externo\nNome do Indicador: ${ind.indicatorName}\nEquação Real: ${ind.valueEquation}`

                // Busca valor atual do cache se refValue = 0 ou inválido
                if (!ind.refValue || parseFloat(ind.refValue) === 0) {
                    const currentValue = this.fetchIndicatorValue(ind.valueEquation);
                    if (currentValue !== null) {
                        indObj.structure.refValue = currentValue;
                    } else {
                        indObj.structure.refValue = ind.refValue; // Mantém o original (0)
                    }
                } else {
                    indObj.structure.refValue = ind.refValue;
                }
            } else if (type == 'prev') {
                if (ind.targetEquation && ind.targetEquation == "REFERENCE" && ind.refValue) {
                    indOriginObj.type = "fixed";
                    indOriginObj.value = ind.refValue;
                } else {
                    indOriginObj.type = "external";

                    // Busca valor atual do cache se refValue = 0 ou inválido
                    if (!ind.refValue || parseFloat(ind.refValue) === 0) {
                        const currentValue = this.fetchIndicatorValue(ind.targetEquation);
                        if (currentValue !== null) {
                            indOriginObj.refValue = currentValue;
                        } else {
                            indOriginObj.refValue = ind.refValue; // Mantém o original (0)
                        }
                    } else {
                        indOriginObj.refValue = ind.refValue;
                    }
                }

                indObj = { label: ind.targetEquation, type: 'reference', structure: indOriginObj }
                indObj.structure.desc = `Indicador Externo\nNome do Indicador: ${ind.indicatorName}\nEquação Prevista: ${ind.targetEquation}`
            }

            this.equationList.push(indObj);

            if (this.isCreating) {
                this.updateStorage()
            }
        },

        deleteInEquation(ref, idx) {
            let refInEq = this.equationList[idx];

            if (refInEq != undefined && refInEq.label == ref.label) {
                this.equationList.splice(idx, 1)
            }
        },

        addFuncFormatToEquation(eqArr) {
            this.equationList.push(...eqArr);
            this.$bvModal.hide('funcModal')
            this.modalOp = {};

            if (this.isCreating) {
                this.updateStorage();
            }
        },

        selectReference(ref) {
            this.creatingReference = {};
            if (ref.type == "gemeo") {
                this.tabIndex = 0;
            }
            else if (ref.type == "fixed") {
                this.tabIndex = 1;
            }
            else if (ref.type == "indicator") {
                this.tabIndex = 2;
            }
            else if (ref.type == "safra") {
                this.tabIndex = 3;
            }

            if (ref.type == 'gemeo' && (!ref.value || ref.value == undefined || ref.value == '')) {
                let mapFound = this.mappingList.filter(item => item.map == ref.label)
                if (mapFound.length > 0) {
                    ref.value = mapFound[0].value
                    ref.desc = `Mapeamento XML\nValor: ${mapFound[0].value}`
                    ref.structure.desc = `Mapeamento XML\nValor: ${mapFound[0].value}`
                }
            }

            this.creatingReference = { ...ref };
            this.addLabel = "Atualizar";
        },

        openRemoveModal(ref) {
            this.removingReference = { ...ref }
            this.$bvModal.show('removeReferenceModal');
        },

        removeReference() {
            this.createdReferences = this.createdReferences.filter(item => item.id != this.removingReference.id);

            this.equationList = this.equationList.filter(item =>
                item.type != "reference" || (item.type == "reference" && item.structure.id != this.removingReference.id)
            )
        },

        createNewReference() {
            if (this.tabIndex == 3) {
                let label = `ind_plan_${this.harvestInfo.planTag}_${this.unitId}`
                let structure = { ...this.harvestInfo }
                structure.type = 'plan'
                let indObj = { label: label, type: 'reference', structure: structure }
                indObj.structure.desc = `Variável do Plano de Safra\nNão Editavel\nVariável Referência: ${this.harvestInfo.planTag}\nValor: ${this.harvestInfo.value}`
                this.equationList.push(indObj);

                if (this.isCreating) {
                    this.updateStorage();
                }

                return
            }

            let validateFields = true;

            if (this.referenceType == 'gemeo') {
                validateFields = MediatorIndicatorEditor.validateFields(this.creatingReference, ['map', 'value'], ['', undefined]);
            } else if (this.referenceType == 'fixed') {
                validateFields = MediatorIndicatorEditor.validateFields(this.creatingReference, ['fixedName', 'value'], ['', undefined]);
            }

            if (Object.keys(this.creatingReference).length == 0 || Object.values(this.creatingReference).length == 0 || validateFields == false) {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Campos Vazios', 'Preencha todos os campos da referência.');
                return;
            }

            if (this.addLabel == "Atualizar") {
                this.edited = true;
                this.createdReferences = this.createdReferences.map(item => {
                    if (item.id == this.creatingReference.id) {
                        return { ...this.creatingReference };
                    } else return item;
                });

                this.equationList.forEach(item => {
                    if (item.type == 'reference' && item.structure.id == this.creatingReference.id) {
                        item.label = this.creatingReference.label;
                        if (this.referenceType == 'gemeo') {
                            item.label = this.creatingReference.label;
                            item.desc = `Mapeamento XML\nValor: ${this.creatingReference.value}`
                            item.structure = {}
                            item.structure = { ...this.creatingReference }
                            item.structure.desc = `Mapeamento XML\nValor: ${this.creatingReference.value}`
                        } else if (this.referenceType == 'fixed') {
                            this.creatingReference.desc = `Valor Fixo\nValor: ${this.creatingReference.value}`
                            item.structure.desc = `Valor Fixo\nValor: ${this.creatingReference.value}`
                            item.structure.value = this.creatingReference.value
                        } else {
                            item = { ...this.creatingReference }
                        }
                    }
                });
                this.edited = true
                this.addLabel = "Adicionar";
                this.creatingReference = {}

                let res = this.handleCalc(this.equationList);
                this.idealVal = res;
                this.updateLimitWhenEdit();
                this.enableSave = true

                if (this.isCreating) {
                    this.updateStorage();
                }

                return;
            }

            let newRef = {
                ...this.creatingReference,
                type: this.referenceType,
                id: this.referenceType == 'gemeo' ? `${this.createdReferences.length}-${this.referenceType}` : `${this.createdReferences.length}-${this.referenceType}-${this.creatingReference.label}`
            }

            this.createdReferences.push(newRef);
            this.addLabel = "Adicionar";
            this.creatingReference = {}

            let res = this.handleCalc(this.equationList);
            this.idealVal = res;
            this.updateLimitWhenEdit();
            this.enableSave = true

            if (this.isCreating) {
                this.updateStorage();
            }
        },

        selectMapping(map, val) {
            if (this.creatingReference.id) {
                this.creatingReference.label = map;
                this.creatingReference.map = map;
                this.creatingReference.value = val;
            } else {
                let idMap = `${this.createdReferences.length}-${this.referenceType}`
                this.creatingReference = { id: idMap, label: map, map: map, value: val }
            }
        },

        clearChanges() {
            this.creatingReference = {};
            this.limitCheck = 'both';
            this.addLabel = "Adicionar";

            if (this.isCreating) {
                let localJSON = MediatorIndicatorEditor.calculated

                if (localJSON != null && localJSON != undefined && Object.keys(localJSON).length != 0 && Object.keys(localJSON).length > 1) {
                    this.createdReferences = localJSON.createdRefs
                    this.equationList = localJSON.equation

                    this.disableSup = localJSON.disableSup
                    this.disableInf = localJSON.disableInf
                    this.idealVal = localJSON.idealVal
                    this.supLimit = localJSON.supLimit
                    this.infLimit = localJSON.infLimit
                    this.critic = localJSON.critic
                    this.limitCheck = localJSON.limitCheck

                    this.toSaveOnLocal = MediatorIndicatorEditor.calculated;
                }
            } else {
                this.createdReferences = [...this.originalcreatedReferences];
                this.equationList = [...this.originalequationList];

                let indRule = this.selectedIndicator.indicatorRule.split(" ");

                if (indRule.length > 0) {
                    this.handleCheckLimit(indRule[0]);
                    this.critic = Number(indRule[2]);
                }

                if (this.selectedIndicator.idealRes && this.selectedIndicator.idealRes != '-9999') {
                    this.idealVal = this.selectedIndicator.idealRes;
                } else {
                    let res = this.handleCalc(this.equationList)
                    this.idealVal = res
                }
            }


        },

        clearRefTabs() {
            this.creatingReference = {};
            this.harvestInfo = {};
            this.addLabel = "Adicionar";
        },

        handleOperation(opType, op) {
            if (opType != 'funcs') {
                this.addToEquation(op, 'operation');
                return;
            }

            this.modalOp = op;
            this.$bvModal.show('funcModal');

            if (this.isCreating) {
                this.updateStorage();
            }
        },

        handleActive(newTabIndex) {
            if (newTabIndex == 0) {
                this.referenceType = "gemeo"
            } else if (newTabIndex == 1) {
                this.referenceType = "fixed"
            }
            else if (newTabIndex == 2) {
                this.referenceType = "indicator"
            }
            else if (newTabIndex == 3) {
                this.referenceType = "safra"
            }
        },

        clearEquation() {
            this.equationList = [];

            if (this.isCreating) {
                this.updateStorage();
            }
        },

        undoEquation() {
            this.equationList.pop()

            if (this.isCreating) {
                this.updateStorage();
            }
        },

        refDrag(evt, ref) {
            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('draggedReference', JSON.stringify(ref));
        },

        refEnter(ref, idx) {
            let element = document.getElementById(`${ref.label}-${idx}-equation`);
            element.classList.add('overDrag');
        },

        refLeave(ref, idx) {
            let element = document.getElementById(`${ref.label}-${idx}-equation`);
            element.classList.remove('overDrag');
        },

        refDrop(evt, ref, idx) {
            let element = document.getElementById(`${ref.label}-${idx}-equation`);
            element.classList.remove('overDrag');

            let refMoved = evt.dataTransfer.getData('draggedReference');
            let refToAdd = JSON.parse(refMoved);

            if (!refToAdd.id || refToAdd.id == undefined) {
                this.equationList.splice(idx + 1, 0, { label: refToAdd.label, type: 'operation' });
            } else {
                this.equationList.splice(idx + 1, 0, { label: refToAdd.label, type: 'reference', structure: refToAdd });
            }


            if (this.isCreating) {
                this.updateStorage();
            }
        },

        handleCheckLimit(radio) {
            if (radio == 'up' || radio == '>') {
                this.disableSup = false
                this.disableInf = true
                this.limitCheck = 'up'
            } else if (radio == 'down' || radio == '<') {
                this.disableSup = true
                this.disableInf = false
                this.limitCheck = 'down'
            } else if (radio == 'both' || radio == '=') {
                this.disableSup = false
                this.disableInf = false
                this.limitCheck = 'both'
            }

            this.enableSave = true

            if (this.isCreating) {
                this.updateStorage();
            }
        },

        handleValueLimit(type, val) {
            if (type == "critic") {
                this.critic = Math.abs(Number(val))
                let percentValue = (Number(val) / 100) * Number(this.idealVal)
                this.supLimit = (Number(this.idealVal) + Number(percentValue))
                this.infLimit = (Number(this.idealVal) - Number(percentValue))
            }

            if (type == "sup") {
                if (Number(val) < Number(this.idealVal)) {
                    this.supLimit = Number(this.idealVal);
                    MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Superior abaixo do Ideal', 'O valor superior deve ser maior que o ideal.')
                    return;
                }

                this.supLimit = Number(val);
                let newCritic = (Number(val) * 100) / Number(this.idealVal);
                this.critic = Math.abs(Number(newCritic) - 100);
                this.infLimit = (Number(this.idealVal) - ((Number(this.critic) / 100) * Number(this.idealVal)))
            }

            if (type == "inf") {
                if (Number(val) > Number(this.idealVal)) {
                    this.infLimit = Number(this.idealVal);
                    MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Inferior acima do Ideal', 'O valor inferior deve ser menor que o ideal.')
                    return;
                }

                this.infLimit = Number(val);
                let newCritic = (Number(val) * 100) / Number(this.idealVal);
                this.critic = Math.abs(Number(newCritic) - 100);
                this.supLimit = (Number(this.idealVal) + ((Number(this.critic) / 100) * Number(this.idealVal)))
            }

            this.enableSave = true

            if (this.isCreating) {
                this.updateStorage();
            }
        },

        updateLimitWhenEdit() {
            let percentValue = (Number(this.critic) / 100) * Number(this.idealVal)
            this.supLimit = Number(this.idealVal) + Number(percentValue)
            this.infLimit = Number(this.idealVal) - Number(percentValue)

            if (this.isCreating) {
                this.updateStorage();
            }
        },

        handleCalc(eq) {
            let str = '';
            let equationResult = 0;
            let hasFuncts = false;
            let foundError = false;
            let missingRefValue = false;

            if (eq.length > 0) {
                eq.forEach(item => {
                    if (item.type == 'operation') {
                        if (MediatorIndicatorEditor.advancedFunctionsAllowed.includes(item.label)) hasFuncts = true;
                        str += `${item.label} `;
                    }
                    else if (item.type == 'reference' && item.structure.type == 'gemeo') {
                        // PRIORIZA o cache sobre o mapeamento XML (valores mais atualizados)
                        const cachedValue = this.fetchIndicatorValue(item.label);

                        if (cachedValue !== null && !isNaN(Number(cachedValue))) {
                            // Usa valor do cache (mais atualizado)
                            str += `${cachedValue} `
                        } else if (item.structure.value && item.structure.value != '-9999') {
                            // Se não tiver no cache, usa valor já carregado
                            str += `${item.structure.value} `
                        }
                        else {
                            // Por último, tenta buscar no mapeamento XML
                            let mapFound = this.mappingList.filter(map => map.map == item.label)

                            if (mapFound.length > 0) {
                                item.structure.value = mapFound[0].value
                                str += `${item.structure.value} `
                                item.desc = `Mapeamento XML\nValor: ${item.structure.value}`
                                item.structure.desc = `Mapeamento XML\nValor: ${item.structure.value}`
                            } else {
                                foundError = true;
                            }
                        }
                    }
                    else if (item.type == 'reference' && item.structure.type == 'plan') {
                        let planName = this.harvestPlanList.filter(plan => item.label.toLowerCase().includes(plan.planTag.toLowerCase()))

                        if (planName.length > 0) {
                            item.structure.value = planName[0].value
                            item.desc = `Variável do Plano de Safra\nNão Editavel\nVariável Referência: ${planName[0].planTag}\nValor: ${planName[0].value}`
                            item.structure.desc = `Variável do Plano de Safra\nNão Editavel\nVariável Referência: ${planName[0].planTag}\nValor: ${planName[0].value}`

                            str += `${item.structure.value} `

                        } else {
                            foundError = true;
                        }
                    }
                    else if (item.type == 'reference' && item.structure.type == 'external') {
                        // Indicadores externos (Real/Previsto) usam refValue para cálculo do Valor Ideal
                        if (item.structure.refValue && !isNaN(Number(item.structure.refValue))) {
                            str += `${item.structure.refValue} `
                        } else {
                            missingRefValue = true;
                            foundError = true;
                        }
                    }
                    else if (item.type == 'reference' && (item.structure.type == 'fixed')) str += `${item.structure.value} `
                    else if (item.type == 'reference' && item.structure.type == 'outro') {
                        // Tipo "outro" - referência desconhecida, tenta buscar valor do cache
                        const cachedValue = this.fetchIndicatorValue(item.label);

                        if (cachedValue !== null && !isNaN(Number(cachedValue))) {
                            str += `${cachedValue} `
                        } else {
                            // Se não encontrar no cache, tenta usar o label como variável na expressão
                            str += `${item.label} `
                        }
                    }
                    else if (item.type == 'calc') str += `${item.structure.status} `
                });

                if (foundError == true) {
                    if (missingRefValue) {
                        MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Valor Ideal Indisponível', 'Não foi possível calcular o Valor Ideal: indicadores externos na equação não possuem valor de referência (refValue). O Valor Ideal ficará zerado.')
                    } else {
                        MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Valores Inválidos', 'Valores inválidos (-9999) encontrados no cálculo do valor ideal.')
                    }
                    return 0
                }

                // Converte sintaxe if/then/else para ternário JavaScript ANTES de processar
                if (str.toLowerCase().includes('if') && str.toLowerCase().includes('then') && str.toLowerCase().includes('else')) {
                    // Padrão: if (condição) then valor1 else valor2
                    // Converte para: (condição) ? valor1 : valor2
                    str = str.replace(/if\s*\(/gi, '(')
                             .replace(/\)\s*then\s+/gi, ') ? ')
                             .replace(/\s+else\s+/gi, ' : ');

                    // Converte operadores de comparação
                    str = str.replace(/<>/g, '!=');  // <> vira !=

                    // Converte = para == (somente quando é comparação, não quando já é ==, <=, >=, !=)
                    str = str.replace(/([^<>!=])\s*=\s*([^=])/g, '$1 == $2');

                    // Converte AND/OR para JavaScript
                    str = str.replace(/\s+and\s+/gi, ' && ');
                    str = str.replace(/\s+or\s+/gi, ' || ');

                    // Após conversão, não precisa mais processar como função
                    hasFuncts = false;
                }

                if (hasFuncts == true) {
                    let allFuncts = this.findFuncsInStr(str)

                    if (allFuncts.length > 0) {
                        let allRes = 0;
                        let someError = false;

                        for (let functs of allFuncts) {
                            let condit = '';
                            let functResult = 0;

                            if (functs.func.includes("cavg") || functs.func.includes("cavg") || functs.func.includes("cwavg") || functs.func.includes("csub")
                                || functs.func.includes("csum") || functs.func.includes("cdiv") || functs.func.includes("cmul") || functs.func.includes("ccount")) condit = functs.args[0];


                            if (functs.func.includes("avg")) {
                                let validCount = 0;
                                for (let idx in functs.args) {
                                    if (idx == 0) continue;

                                    if (functs.args[idx] == '-9999' || isNaN(Number(functs.args[idx]))) {
                                        someError = true;
                                        continue;
                                    }

                                    if (functs.func.includes("wavg")) {
                                        let itemArr = functs.args[idx].split(":")

                                        functResult += (Number(itemArr[0]) + Number(itemArr[1]))
                                    } else {
                                        functResult += Number(functs.args[idx])
                                    }
                                    validCount++;
                                }

                                // Evita divisão por zero
                                if (validCount > 0) {
                                    functResult = Number(functResult) / validCount
                                } else {
                                    functResult = 0;
                                }

                                if (condit != '') {
                                    let verify = this.runCondition(condit)

                                    if (verify != null && verify == false) functResult = 0
                                }
                            } else if (functs.func.includes("sum")) {
                                for (let idx in functs.args) {
                                    if (idx == 0) continue;

                                    if (functs.args[idx] == '-9999' || isNaN(Number(functs.args[idx]))) {
                                        someError = true;
                                        continue;
                                    }

                                    functResult += Number(functs.args[idx])
                                }

                                if (condit != '') {
                                    let verify = this.runCondition(condit)

                                    if (verify != null && verify == false) functResult = 0
                                }
                            } else if (functs.func.includes("sub")) {
                                for (let idx in functs.args) {
                                    if (idx == 0) continue;

                                    if (functs.args[idx] == '-9999' || isNaN(Number(functs.args[idx]))) {
                                        someError = true;
                                        continue;
                                    }

                                    functResult -= Number(functs.args[idx])
                                }

                                if (condit != '') {
                                    let verify = this.runCondition(condit)

                                    if (verify != null && verify == false) functResult = 0
                                }
                            } else if (functs.func.includes("mul")) {
                                for (let idx in functs.args) {
                                    if (idx == 0) continue;

                                    if (functs.args[idx] == '-9999' || isNaN(Number(functs.args[idx]))) {
                                        someError = true;
                                        continue;
                                    }

                                    functResult *= Number(functs.args[idx])
                                }

                                if (condit != '') {
                                    let verify = this.runCondition(condit)

                                    if (verify != null && verify == false) functResult = 0
                                }
                            } else if (functs.func.includes("div")) {
                                for (let idx in functs.args) {
                                    if (idx == 0) continue;

                                    if (functs.args[idx] == '-9999' || isNaN(Number(functs.args[idx]))) {
                                        someError = true;
                                        continue;
                                    }

                                    let divisor = Number(functs.args[idx]);
                                    // Evita divisão por zero
                                    if (divisor === 0) {
                                        functResult = 0;
                                        someError = true;
                                        break;
                                    }
                                    functResult /= divisor;
                                }

                                if (condit != '') {
                                    let verify = this.runCondition(condit)

                                    if (verify != null && verify == false) functResult = 0
                                }
                            } else if (functs.func.includes("count")) {
                                functResult -= Number(functs.args.length)

                                if (condit != '') {
                                    let verify = this.runCondition(condit)

                                    if (verify != null && verify == false) functResult = 0
                                }
                            } else if (functs.func.includes("min") || functs.func.includes("max")) {
                                let auxArr = []

                                for (let idx in functs.args) {
                                    if (idx == 0) continue;

                                    if (functs.args[idx] == '-9999' || isNaN(Number(functs.args[idx]))) {
                                        someError = true;
                                        continue;
                                    }

                                    auxArr.push(Number(functs.args[idx]))
                                }

                                if (functs.func.includes("min")) functResult = Math.min.apply(null, auxArr)
                                if (functs.func.includes("max")) functResult = Math.max.apply(null, auxArr)

                                if (condit != '') {
                                    let verify = this.runCondition(condit)

                                    if (verify != null && verify == false) functResult = 0
                                }
                            }

                            allRes = functResult;

                        }

                        equationResult = allRes;

                        if (someError == true) {
                            MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Valores Inválidos', 'Valores inválidos (-9999) encontrados no cálculo do valor ideal.')
                            return 0
                        }
                    }
                } else {
                    try {
                        equationResult = eval(str);
                    } catch (e) {
                        // Erro de sintaxe na avaliação da expressão
                    }
                }
            }

            // Valida o resultado para evitar NaN, Infinity ou valores inválidos
            if (isNaN(equationResult) || !isFinite(equationResult)) {
                return 0;
            }

            return equationResult;
        },

        findFuncsInStr(expression) {
            let regex = /\b(?:avg|wavg|cavg|cwavg|min|max|sum|csum|sub|csub|cmul|cdiv|ccount|if|else|then)\s*\(([^()]*)\)/g;
            let matches = [];
            let match;

            while ((match = regex.exec(expression)) !== null) {
                let args = match[1].split(',').map(arg => arg.trim());
                matches.push({ func: match[0], args: args });
            }

            return matches;
        },

        runCondition(strCondit, value) {
            let opArr = ['<', '>', '<=', '>=', '<>', '=']
            let opFound = [];
            let cleanCondit = strCondit.replaceAll("'", "").replaceAll(",", "").trim();

            opArr.forEach(item => {
                if (cleanCondit.includes(item)) {
                    opFound.push(item);
                    cleanCondit = cleanCondit.replaceAll(item, "").trim();
                }
            })

            for (let op of opFound) {
                if (op == '>' && isNaN(Number(cleanCondit))) return Number(value) > Number(cleanCondit)
                if (op == '<' && isNaN(Number(cleanCondit))) return Number(value) < Number(cleanCondit)
                if (op == '>=' && isNaN(Number(cleanCondit))) return Number(value) >= Number(cleanCondit)
                if (op == '<=' && isNaN(Number(cleanCondit))) return Number(value) <= Number(cleanCondit)
                if (op == '<>' && isNaN(Number(cleanCondit))) return Number(value) != Number(cleanCondit)
                if (op == '=' && isNaN(Number(cleanCondit))) return Number(value) == Number(cleanCondit)
            }

            return null;

        },

        updateStorage() {
            this.toSaveOnLocal.createdRefs = this.createdReferences;
            this.toSaveOnLocal.equation = this.equationList;

            this.toSaveOnLocal.disableSup = this.disableSup;
            this.toSaveOnLocal.disableInf = this.disableInf;
            this.toSaveOnLocal.idealVal = this.idealVal;
            this.toSaveOnLocal.supLimit = this.supLimit;
            this.toSaveOnLocal.infLimit = this.infLimit;
            this.toSaveOnLocal.critic = this.critic;
            this.toSaveOnLocal.limitCheck = this.limitCheck;

            MediatorIndicatorEditor.calculated = this.toSaveOnLocal;
        },

        async applyCalculatedReferences() {
            let originalCompare = this.originalequationList.map(item => JSON.stringify(item)).join("");
            let currentCompare = this.equationList.map(item => JSON.stringify(item)).join("");
            if (this.equationList.length == 0 || (originalCompare == currentCompare && this.edited == false)) {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Sem Modificações', 'Não existem modificações para salvar.');
                return;
            }

            if (this.validExp.status == false) {
                MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Expressão Inválida', 'A expressão criada não retornará valor, por favor verifique se está correta.');
                return;
            }

            this.isReloading = true;


            let sendToBack = {
                saveOnTree: {},
                saveOnCalculate: {},
                saveOnCollector: [],
            }

            let limitType = this.limitCheck == 'up' ? '>' : this.limitCheck == 'down' ? '<' : this.limitCheck == 'both' ? '=' : ''
            let limitLabel = this.limitCheck == 'up' ? 'LSE' : this.limitCheck == 'down' ? 'LIE' : this.limitCheck == 'both' ? 'LIE e LSE' : ''

            let ruleStr = `${limitType} ${this.critic} ${this.critic}`;

            MediatorIndicatorEditor.formatCalculatedToReturn(this.equationList, sendToBack, this.selectedIndicator)

            sendToBack.saveOnTree.limitRule = ruleStr
            sendToBack.saveOnTree.limitCritic = this.critic.toString();
            sendToBack.saveOnTree.limitLabel = limitLabel

            await axios.post(`${urlMainAPI}/SaveEditorIndicatorPrevTag`, JSON.stringify({
                saveOnTree: sendToBack.saveOnTree,
                saveOnCalculate: sendToBack.saveOnCalculate,
                saveOnCollector: sendToBack.saveOnCollector
            }), {
                headers: { 'Content-Type': 'application/json' }
            })
                .then(async res => {
                    if (res.status == 200) {
                        await this.$emit("reloadIndicator", this.selectedIndicator)
                        this.originalcreatedReferences = [...this.createdReferences];
                        this.originalequationList = [...this.equationList];

                        defaultSuccess('Valor Previsto atualizado com sucesso!')
                    }
                })
                .catch(() => {
                    showError('Falha ao salvar o valor previsto.')
                });

            this.isReloading = false;
        }
    },

    created() {
        this.loading = false;

        this.mappingList = MediatorIndicatorEditor.mappingList;
        this.harvestPlanList = MediatorIndicatorEditor.harvestPlanList;
    }
}
</script>
<style scoped>
@import '../commons/commonStyles.css';


.refs-forms .ref-tab {
    width: 25rem;

}

.map-inputs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    column-gap: 0.5rem;
    margin-top: 0.5rem;
}

.map-inputs label {
    position: relative;
}

.map-inputs label span {
    position: absolute;
    top: -.8rem;
    left: 0.4rem;
    background-color: white;
    font-size: 0.8rem;
    color: #FF5F00;
    padding-left: 0.3rem;
    padding-right: 0.5rem;
    font-weight: 500;
}

.map-inputs label input {
    padding: 0.5rem !important;
    width: 100%;
    font-size: 0.8rem;
}

.limits {
    border: 1px solid #A7A7A7;
    border-radius: 0.2rem;
    height: 25%;
    margin-top: 1%;
    display: flex;
    flex-direction: column;

    padding: 0.5rem;
    /* align-items: center; */
    justify-content: space-between;
}

.limit-inputs {
    margin-top: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 1rem;

}

.limit-inputs label {
    position: relative;
}

.limit-inputs label span {
    position: absolute;
    top: -.8rem;
    left: 0.4rem;
    background-color: white;
    font-size: 0.8rem;
    color: #FF5F00;
    padding-left: 0.3rem;
    padding-right: 0.5rem;
    font-weight: 500;
}

.limit-inputs label input {
    padding: 0.3rem !important;
}

.limit-inputs label input[disabled="disabled"] {
    background-color: #f0f0f0;
}

.limit-radios {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    column-gap: 1rem;
}

.limit-radios label {
    cursor: pointer;
    display: flex !important;
    align-items: center !important;
    column-gap: 0.5rem !important;
}

.map-list {
    margin-top: 0.3rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
}

.map-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #A7A7A7;
    color: #000;
    padding: 0 0.3rem;
    width: 100%;
    background-color: #f0f0f0;
}

.map-table {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 9rem;
    font-size: 1rem;
    width: 100%;
    border: 1px solid #8a8a8a;
    border-top: none;
}

.map-table section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.3rem;
    cursor: pointer;
    color: #1a1a1a;

    border-top: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
}

.map-table section span {
    font-size: 0.8rem;
}

.map-table section:hover {
    background-color: #e4e4e4;
}

.refs-container {
    grid-template-columns: 1fr 0.7fr 3fr;
}

.searchMap {
    width: 100%;
    padding: 0.4rem 0.2rem;
    margin: 0.3rem 0;
}

.referenceItem span {
    font-size: 0.8rem;
    max-width: 5.6rem;

}

.overDrag::after {
    content: "";
    display: block;
    position: absolute;
    right: -6px;
    top: 0;
    width: 4px;
    height: 100%;
    border-radius: 0;
    background-color: #00A39F;
    border: none;
}

.addIndBtns {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.5rem;

    font-size: 0.8rem;
    font-weight: bold;
}

.addIndBtns section {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 0.3rem;
    border: 1px solid #fff;
    padding: 0.2rem;
    background-color: #00A39F;
    color: #fff;
    border-radius: 0.2rem;
    cursor: pointer;
}

.addPrev {
    background-color: #FF5F00 !important;
}

@media (min-height: 900px) {
    .limit-radios {
        font-size: 1.2rem;
    }

    .limit-inputs label input {
        padding: 1rem !important;
    }

    .refs-container {
        grid-template-columns: 1fr 0.5fr 2fr;
    }

    .map-table section span {
        font-size: 1rem;
    }

    .map-table {
        max-height: 22rem;
    }

    .map-list {

        width: 32rem;

    }

    .refs-forms .ref-tab {
        width: 100%;

    }

    .referenceItem span {
        max-width: 9.7rem;

    }
}
</style>